import { CollectionSummary } from '@qkindex/contracts';
import { useAlertSource } from '../alerts/AlertsProvider';
import { useLocationOperations } from './useLocationOperations';

export function LocationOperationFeedback({
  controller,
  collections,
  userId,
}: {
  controller: ReturnType<typeof useLocationOperations>;
  collections: CollectionSummary[];
  userId: string;
}) {
  useAlertSource(
    userId,
    'location-operations',
    controller.operations.map((operation) => ({
      id: operation.id,
      title: `${collections.find((entry) => entry.collectionId === operation.sourceCollectionId)?.name || 'Collection'} → ${operation.destination.name}`,
      severity:
        operation.failed.length || operation.blockedReason ? 'warning' : 'info',
      message:
        operation.blockedReason ||
        (operation.state === 'queued'
          ? 'Not yet submitted. Keep this page open.'
          : operation.state === 'uncertain'
            ? 'Awaiting confirmation. Retrying the original request is safe.'
            : operation.state === 'failed'
              ? `${operation.completed.length} updated, ${operation.failed.length} couldn’t be updated.`
              : 'Updating… You can continue using the app.'),
      action:
        operation.state === 'uncertain' || operation.state === 'failed'
          ? {
              label:
                operation.state === 'failed' ? 'Retry failed items' : 'Retry',
              disabled: operation.busy || Boolean(operation.blockedReason),
              run: () => controller.retry(operation.operationId),
            }
          : undefined,
    })),
  );
  return null;
}
